module.exports = __webpack_public_path__ + "img/australian-national-university.42be86fa.png";